<template>
  <CCard style="position: sticky; top: 5rem">
    <CCardHeader class="px-3 py-2">
      <i class="fas fa-award"></i> &nbsp;
      <strong>Top 5 Favorite Ideas</strong>
    </CCardHeader>
    <CCardBody class="top-content px-3 py-2">
      <div class="idea-side-list">
        <div
          v-for="(item, i) in items"
          :key="`item-${i}`"
          class="item pt-2 pb-3"
          :class="{ 'border-bottom': i + 1 < items.length }"
        >
          <router-link
            :to="{ name: 'IdeaDetail', params: { id: item.Id } }"
            class="text-dark"
            :title="item.Title"
          >
            <h6 class="title">{{ i + 1 }}. {{ item.Title }}</h6>
          </router-link>
          <div class="small text-muted mb-1">
            <i class="fas fa-clock"></i>
            {{ showDateTime(item.UpdatedAt) }}
            &nbsp;|&nbsp; <i class="fas fa-globe"></i> {{ item.Area.Name }}
          </div>
          <div class="small">
            By
            <strong>{{
              item.IsAnonymous ? "Anonymous" : item.CreatedByNavigation.Name
            }}</strong>
          </div>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  props: ["queryObject"],
  data() {
    return {
      items: [],
    };
  },
  async mounted() {
    this.getTopItems(this.queryObject);
  },
  watch: {
    queryObject(val) {
      if (this.timeoutQuery) {
        clearTimeout(this.timeoutQuery);
      }
      this.timeoutQuery = setTimeout(() => {
        this.getTopItems(val);
      }, 500);
    },
  },
  methods: {
    async getTopItems(queryObj) {
      let result = [];
      let filters = [`SipIdeaOfChallenges/any() eq false`];
      //filters.push(`IsAnonymous eq false`);
      if (queryObj) {
        if (JSON.stringify(queryObj.area) != JSON.stringify(this.area)) {
          let areas = queryObj.area ?? [];
          if (areas && areas.length) {
            filters.push(`AreaId in (${areas.join(`, `)})`);
          }
        }
      }

      let resp = await this.$http.get(`odata/SipIdea`, {
        params: {
          $top: 5,
          $select: `Id,Title,UpdatedAt,IsAnonymous`,
          $filter: filters.join(` and `),
          $orderby: "Votes desc",
          $count: false,
          $expand: `Area($select=Name),CreatedByNavigation($select=Name,Email)`,
        },
      });
      if (resp && resp.status == 200) {
        result = resp.data.value;
      }

      this.items = result;
    },

    showDateTime(createdAt) {
      return this.$moment().diff(this.$moment(createdAt), "weeks") < 1
        ? this.$moment(createdAt).fromNow()
        : this.$moment(createdAt).format("DD MMM YYYY, HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  max-height: 17px;
  overflow: hidden;
}

.top-content {
  overflow-y: auto;
  max-height: calc(100vh - 9rem);
}
</style>
